<template>
  <div>
    {{ $t('compTransitionQuotaStatus.quota-info') }}
    <quota-bar
      :label="$t('compTransitionQuotaStatus.quota-action')"
      :quota="actionSize"
      :additionalQuota="additionalSize"
      :maxQuota="actionQuota"
    ></quota-bar>
    <quota-bar
      :label="$t('compTransitionQuotaStatus.quota-global')"
      :quota="globalSize"
      :additionalQuota="additionalSize"
      :maxQuota="globalQuota"
    ></quota-bar>
  </div>
</template>

<script>
export default {
  name: 'QuotaStatus',
  props: {
    globalSize: {
      type: Number
    },
    globalQuota: {
      type: Number
    },
    actionSize: {
      type: Number
    },
    actionQuota: {
      type: Number
    },
    additionalSize: {
      type: Number,
      required: false,
      default: 0
    }
  },
  components: {
    'quota-bar': () => import('./QuotaBar.vue')
  }
}
</script>
